import { PropsWithChildren, CSSProperties } from "react";
import { Button as BSButton, Spinner } from "react-bootstrap";

interface ButtonProps extends PropsWithChildren {
  showSpinner?: boolean;
  type?: "button" | "submit" | "reset";
  size?: "sm" | "lg";
  className?: string;
  children?: React.ReactNode;
  onClick?: (e?: any) => void;
  variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark" | "cancel" | "outline-primary";
  ref?: React.RefObject<HTMLButtonElement>;
  style?: CSSProperties; 
  disabled?: boolean; 
}

export function Button({ 
  showSpinner = false,
  type = "button",
  className,
  size = "sm",
  children,
  onClick,
  variant = "primary",
  ref,
  style,
  disabled = false 
 }: Readonly<ButtonProps>) {
  return (
    <BSButton
      type={type}
      variant={variant}
      ref={ref}
      size={size}
      onClick={onClick}
      className={`btn w-100 ${className}`}
      style={{ padding: "0.5rem 0.75rem", ...style }} 
      disabled={disabled} 
    >
      {
        showSpinner ?
          (<Spinner size="sm" animation="border" variant="light" as="span" role="output" aria-hidden="true" />) :
          children
      }
    </BSButton>
  );
}

export default Button;
